import './App.css';
// import './components/style.css'

import AploadPaper from './components/paper_apload';
import AploadBook from './components/book_upload';
import Login from './components/login';
import {toast} from 'react-hot-toast';

import {BrowserRouter as Router, Link, Route, Routes} from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav, NavDropdown, Form, Button, ButtonGroup } from 'react-bootstrap';
import { Toaster } from 'react-hot-toast';
import { useEffect, useState } from 'react';
import authService from './services/authService';
import Subscriptions from './components/subscriptions';
import Papers from './components/papers';
import NavbarComponet from './components/navbar';
import ProtectedRoute from './services/protectedRoute';
import AddScriptForm from './components/marking_script_upload';
import AddMock from './components/add_mock';
import Mocks from './components/mocks';
import AddQuestion from './components/add_question';
import QuestionList from './components/view_mock';

function App() {
//   const [currentUser, setCurrentUser] = useState(undefined)
//   useEffect(()=>{
//     const user = authService.getCurrentUser()
//     if(user){
//       setCurrentUser(user)
//     }
//   }, [])

//   const authButton = () => {
//     if (!currentUser) {
//         return (
//             <ButtonGroup>
//                 <Button variant="secondary" as={Link} to="/login">Login</Button>
//             </ButtonGroup>
//         )
            
//     } else {
//         return <Button variant="secondary" onClick={handleLogoutClick}>Logout</Button>
//     }
// }

// const handleLogoutClick = () => {
//   localStorage.removeItem("user");
//   toast.success('Logout Successfully')
//   window.location.href('/login')
//   window.location.reload();
// }

  return (
    <Router>
      <div className='"w-100 p-3"'>
        <NavbarComponet/>
        <Toaster position='top-right' toastOptions={{duration: 2000}}/>        
        <Routes>
          <Route element= {<ProtectedRoute/>}>            
            <Route path='/create' element ={<AploadPaper/>}/>
            <Route path='/subscriptions' element ={<Subscriptions/>}/>
            <Route path='/papers' element ={<Papers/>}/>
            <Route path='/addBook' element ={<AploadBook/>}/>
            <Route path='/addScript/:paper_id' element ={<AddScriptForm/>}/>
            <Route path='/add_mock' element ={<AddMock/>}/>
            <Route path='/mocks' element ={<Mocks/>}/>
            <Route path='/addQuestion/:mock_id' element ={<AddQuestion/>}/>
            <Route path='/view/:mock_id' element ={<QuestionList/>}/>
          </Route>
          <Route path='/login' exact element={<Login/>}/>
        </Routes>        
      </div>
    </Router>
    
  );
}
export default App;
